import PropTypes from 'prop-types';

export default PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
    hideDeactivationSwitch: PropTypes.bool,
    content: PropTypes.element,
    menuItemComponent: PropTypes.node,
})